import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=88d84c60&scoped=true&lang=pug&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.scss?vue&type=style&index=0&id=88d84c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d84c60",
  null
  
)

export default component.exports